import { faMoneyBillWave } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, useTheme } from '@mui/material';
import AccountLinkButton from 'components/Stripe/AccountLinkButton/AccountLinkButton';
import StripeDashboardButton from 'components/Stripe/DashboardButton/StripeDashboardButton';
import { GetOrganizationData } from 'lib/graphql/entities/organization/types';
import { FormattedMessage } from 'react-intl';

import {
  CenteredIcon,
  RoundCircleBackground,
  SectionContainer,
  StripeDescription,
  StripeSection,
} from './styles';

interface StripeAccountBannerProps {
  organization: GetOrganizationData;
}

function StripeAccountBanner(props: StripeAccountBannerProps) {
  const { organization } = props;
  const theme = useTheme();

  const canReceivePayments = organization?.stripeAccountLinked && organization.payoutEnabled;

  let titleId;
  switch (true) {
    case organization?.stripeAccountLinked && !organization.payoutEnabled:
      titleId = 'stripe_support_linked';
      break;
    case canReceivePayments:
      titleId = 'stripe_support_linked_payouts_enabled';
      break;
    default:
      titleId = 'stripe_support';
  }

  return (
    <SectionContainer>
      <Grid container alignItems="center" justifyContent="center">
        <Grid item lg={1} xs={12} display="flex" justifyContent="center">
          <RoundCircleBackground>
            <CenteredIcon>
              <FontAwesomeIcon icon={faMoneyBillWave} size="3x" color={theme.palette.secondary.main} />
            </CenteredIcon>
          </RoundCircleBackground>
        </Grid>
        <Grid item lg={7.5} xs={12}>
          <StripeSection>
            <FormattedMessage id={titleId} />
            <StripeDescription>
              <FormattedMessage id={organization?.stripeAccountLinked ? 'stripe_support_description_linked' : 'stripe_support_description'} />
            </StripeDescription>
          </StripeSection>
        </Grid>
        <Grid item lg={3.5} xs={12} display="flex" alignItems="center" justifyContent="center">
          {!canReceivePayments ? (
            <AccountLinkButton
              stripeAccountId={organization.stripeAccountId}
              stripeAccountLinked={organization.stripeAccountLinked}
              canReceivePayments={canReceivePayments || false}
            />
          ) : (
            <StripeDashboardButton organization={organization} />
          )}
        </Grid>
      </Grid>
    </SectionContainer>
  );
}

export default StripeAccountBanner;
